import { createContext, useContext, useState } from "react";

const InvoicesContext = createContext();

export const useInvoices = () => {
  const context = useContext(InvoicesContext);
  if (!context) {
    throw new Error("useInvoices must be used within an InvoicesProvider");
  }
  return context;
};

export const InvoicesProvider = ({ children }) => {
  const [invoices, setInvoices] = useState([]);
  return (
    <InvoicesContext.Provider
      value={{
        invoices,
        setInvoices,
      }}
    >
      {children}
    </InvoicesContext.Provider>
  );
};

export default InvoicesContext;
